//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import {
  faMapMarker,
  faDatabase,
  faSearch,
  faMobileAlt,
  faBug,
  faUsers,
  faSync,
  faClock,
  faPuzzlePiece,
  faTasks,
  faPaperPlane,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import {
  faGithub,
  faLinkedin,
  faTwitter,
  faYoutube,
  faFacebook,
  faLaravel,
  faHtml5,
  faBootstrap,
  faJsSquare,
  faVuejs,
  faAngular,
  faDocker,
  faJira,
  faNodeJs,
  faNpm,
  faPython,
  faGitAlt,
  faSass,
  faJenkins,
  faSteam,
  faSkype,
  faLastfm,
  faTumblr,
} from '@fortawesome/free-brands-svg-icons';
import * as dayjs from 'dayjs';
import countries from 'i18n-iso-countries';
import englishCountries from 'i18n-iso-countries/langs/en.json';
import Mailgo from '@/components/mailgo.vue';
import ImageSources from '@/mixins/srcset';
import Hero from '~/components/hero';

countries.registerLocale(englishCountries);

export default {
  components: {
    Mailgo,
    Hero,
  },
  mixins: [ImageSources],
  async asyncData({ $content, route }) {
    const slug = route.params.slug;
    const {
      basics: {
        profiles,
        firstname,
        lastname,
        label,
        email,
        phone,
        location: {
          city,
          region,
          countryCode,
          postalcode: postcode,
          streetAddress,
        },
        summary,
      },
      work,
      education,
      skills,
      attributes,
    } = await $content('team', slug).fetch();

    const locale = 'en';
    const country = countries.getName(countryCode, locale);
    return {
      image: `/img/team/${slug}.png`,
      profiles,
      firstname,
      lastname,
      email,
      phone,
      label,
      country,
      region,
      city,
      streetAddress,
      postcode,
      summary,
      work,
      education,
      skills,
      attributes,
    };
  },
  data: () => ({
    icons: {
      faGithub,
      faLinkedin,
      faTwitter,
      faYoutube,
      faFacebook,
      faLaravel,
      faHtml5,
      faBootstrap,
      faJsSquare,
      faVuejs,
      faAngular,
      faDocker,
      faJira,
      faNodeJs,
      faNpm,
      faPython,
      faGitAlt,
      faSass,
      faJenkins,
      faDatabase,
      faSearch,
      faMobileAlt,
      faBug,
      faUsers,
      faSync,
      faClock,
      faPuzzlePiece,
      faTasks,
      faPaperPlane,
      faSteam,
      faSkype,
      faLastfm,
      faTumblr,
    },
    faEnvelope,
    faPhone,
    faMapMarker,
  }),
  head() {
    return {
      title: 'Resume',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.summary,
        },
      ],
    };
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('MMMM YYYY');
    },
    columns(items, cols = 2) {
      const columns = [];
      if (items && Array.isArray(items) && items.length) {
        const mid = Math.ceil(items.length / cols);
        for (let col = 0; col < cols; col++) {
          columns.push(items.slice(col * mid, col * mid + mid));
        }
      }
      return columns;
    },
  },
};
